import { handleAction } from 'uix/actions';
import { setLanguage, updateBaseLanguage } from './actions';
import { switchLanguageFormat } from 'uix/utils/format';
import { mergeI18nLayers } from './utils';
import { mapItems, size } from 'ldash';
export const config = [
    handleAction(setLanguage, (config, action)=>{
        let { dname, i18ndata, cacheKeys } = action.payload;
        if (i18ndata && cacheKeys) {
            let ddata = config.ddata[dname];
            let nextI18n = {
                ...ddata.i18n,
                ...i18ndata
            };
            ddata = {
                ...ddata,
                i18n: nextI18n,
                i18nResolved: mergeI18nLayers(config.instance.i18n, nextI18n),
                cacheKeys: {
                    ...ddata.cacheKeys,
                    ...cacheKeys
                }
            };
            return {
                ...config,
                ddata: {
                    ...config.ddata,
                    [dname]: ddata,
                    [ddata.id]: ddata
                }
            };
        }
        return config;
    }),
    handleAction(updateBaseLanguage, (config, { payload })=>{
        let bundle = payload.bundle;
        let cacheKeys = payload.cacheKeys;
        if (size(bundle) === 0) {
            if (size(cacheKeys) === 0) {
                return config;
            }
            return {
                ...config,
                instance: {
                    ...config.instance,
                    cacheKeys: {
                        ...config.instance.cacheKeys,
                        ...cacheKeys
                    }
                }
            };
        }
        let current = config.instance.i18n;
        let next = {
            ...current
        };
        for (let [language, data] of mapItems(bundle, (language, data)=>[
                language,
                data
            ])){
            next[language] = {
                ...next[language],
                ...data
            };
        }
        let updatedDomains = mapItems(config.ddata, (key, domainData)=>[
                key,
                {
                    ...domainData,
                    i18nResolved: mergeI18nLayers(next, domainData.i18n)
                }
            ], (key, domainData)=>domainData && key === domainData.name);
        let ddata = {
            ...config.ddata
        };
        for (let [, domainData] of updatedDomains){
            ddata[domainData.name] = domainData;
            ddata[domainData.id] = domainData;
        }
        let nextInstanceCacheKeys = {
            ...config.instance.cacheKeys,
            ...cacheKeys
        };
        return {
            ...config,
            instance: {
                ...config.instance,
                i18n: next,
                cacheKeys: nextInstanceCacheKeys
            },
            ddata
        };
    })
];
export const meta = [
    handleAction(setLanguage, (meta, { payload })=>{
        switchLanguageFormat(payload.language);
        let merged = payload.merged || {};
        return {
            ...meta,
            language: payload.language,
            i18n: merged[payload.language] || {}
        };
    }, {
        language: null,
        i18n: {}
    })
];
